import React from 'react';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MUIDataTable from 'mui-datatables';

function GetTransactionModal({ opengetTransModal, onClose, data = [] }) {

    const parsedData = typeof data === "string" ? JSON.parse(data) : data;
    const filteredData = parsedData.filter(item => item.symbol === "USDC");
  
    const tableData = filteredData.map(item => ({
      id: item.id,
      Amount: parseFloat(item.amount).toFixed(3),
      completed_at: item.completed_at
    }));

    const getTransactionColumns = [
        {
            name: "id",
            label: "ID"
        },
        {
            name: "Amount",
            label: "Amount",
            options: {
                customBodyRender: (value) => (
                    <div style={{ textAlign: 'center' }}>{value}</div>
                )
            }
        },
        {
            name: "completed_at",
            label: "Completed At"
        }
    ];

    return (
        <Modal open={opengetTransModal} onClose={onClose}>
            <div style={{ backgroundColor: 'white', padding: '20px', position: 'absolute', top: '50%', left: '55%', transform: 'translate(-50%, -50%)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2>Get Transactions</h2>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
                
                <MUIDataTable
                    data={tableData}
                    columns={getTransactionColumns}
                    options={{
                        filter: true,
                        responsive: "standard",
                        selectableRows: "none",
                        rowsPerPage: 5,
                        elevation: 0  // This will remove the Paper effect
                    }}
                />
            </div>
        </Modal>
    )
}

export default GetTransactionModal;
